import { useI18n } from 'next-localization';

import { GenericModal } from '@/components/modals';

import { TELEHEALTH_MODAL } from './constants';

export const TeleHealthModal = (): JSX.Element => {
  const { t } = useI18n();

  return (
    <GenericModal
      name={TELEHEALTH_MODAL}
      label=""
      acceptButtonText={t('OAS.Common.Okay')}
      hideDecline
    >
      <h3 className="mb-4">{t('OAS.Booking.Appointment.TeleHealthModal.Title')}</h3>
      <p>{t('OAS.Booking.Appointment.TeleHealthModal.Description')}</p>
    </GenericModal>
  );
};
